import { writable, readable } from 'svelte/store';
import { toast } from '@zerodevx/svelte-toast';
import { _redirect_uri, _cms_host, _ppm_host, _STRIPE_PUBLIC_KEY, _api_host, _bpm_domain, _recaptcha_key } from './constants.js';


export const masked_menu_components = writable([]);

export const menu_components = [
    // pt: plan_type
    {
        "id": "dashboard", "t": "Dashboard", "i": "fas fa-tachometer-alt", "m": "link", "c": "Dashboard", "pt": 1
    },
    {
        "id": "jobs", "t": "Jobs", "i": "fas fa-calendar-alt", "m": "submenu", "c": "Jobs", "pt": 1,
        "sm_items":[
            {"id": "jobs_today", "t": "Today", "m": "link", "c": "Jobs", "p": "filter=today", "pt": 1},
            {"id": "jobs_tomorrow", "t": "Tomorrow", "m": "link", "c": "Jobs", "p": "filter=tomorrow", "pt": 2},
            {"id": "jobs_yesterday", "t": "Yesterday", "m": "link", "c": "Jobs", "p": "filter=yesterday", "pt": 1},
            {"id": "jobs_future", "t": "Future", "m": "link", "c": "Jobs", "p": "filter=future", "pt": 2},
            {"id": "jobs_past", "t": "Past", "m": "link", "c": "Jobs", "p": "filter=past", "pt": 1},
            {"id": "jobs_pending", "t": "Pending", "m": "link", "c": "Jobs", "p": "filter=pending", "pt": 2},
            {"id": "jobs_card_declined", "t": "Card Declined", "m": "link", "c": "Jobs", "p": "filter=card_declined", "pt": 2},
            {"id": "jobs_assigned", "t": "Assigned", "m": "link", "c": "Jobs", "p": "filter=assigned", "pt": 2},
            {"id": "jobs_not_assigned", "t": "Not Assigned", "m": "link", "c": "Jobs", "p": "filter=not_assigned", "pt": 2},
            {"id": "jobs_completed", "t": "Completed", "m": "link", "c": "Jobs", "p": "filter=completed", "pt": 2},
            {"id": "jobs_approved", "t": "Approved", "m": "link", "c": "Jobs", "p": "filter=approved", "pt": 2},
            {"id": "jobs_unpaid", "t": "Unpaid", "m": "link", "c": "Jobs", "p": "filter=unpaid", "pt": 2},
            {"id": "jobs_charged", "t": "Charged", "m": "link", "c": "Jobs", "p": "filter=charged", "pt": 2},
            {"id": "jobs_all", "t": "All", "m": "link", "c": "Jobs", "p": "filter=all", "pt": 1},
        ]
    },
    {  
        "id": "users", "t": "Users", "i": "fas fa-users", "m": "submenu", "c": "Users", "pt": 1,
        "sm_items":[
            {"id": "users_all", "t": "All", "m": "link", "c": "Users", "p": "filter=all", "pt": 1},
            {"id": "users_owner", "t": "Owner", "m": "link", "c": "Users", "p": "filter=owner", "pt": 1},
            {"id": "users_admins", "t": "Admins", "m": "link", "c": "Users", "p": "filter=admins", "pt": 1},
            {"id": "users_managers", "t": "Managers", "m": "link", "c": "Users", "p": "filter=managers", "pt": 1},
            {"id": "users_leads", "t": "Leads", "m": "link", "c": "Users", "p": "filter=leads", "pt": 10},
            {"id": "users_clients", "t": "Clients", "m": "link", "c": "Users", "p": "filter=clients", "pt": 2},
            {"id": "users_all_crew", "t": "All Crew", "m": "link", "c": "Users", "p": "filter=all_crew", "pt": 2},
            {"id": "crew_contractors", "t": "Contractors", "m": "link", "c": "Users", "p": "filter=contractors", "pt": 1},
            {"id": "crew_employees", "t": "Employees", "m": "link", "c": "Users", "p": "filter=employees", "pt": 1},
            {"id": "users_applicants", "t": "Applicants", "m": "link", "c": "Users", "p": "filter=applicants", "pt": 1},
            {"id": "users_vendors", "t": "Vendors", "m": "link", "c": "Users", "p": "filter=vendors", "pt": 1},
            {"id": "users_inactive", "t": "Inactive", "m": "link", "c": "Users", "p": "filter=inactive", "pt": 0},    
            {"id": "users_import", "t": "Import", "m": "link", "c": "Usersimport", "pt": 1},    
        ]
    },
    {
        "id": "invoices", "t": "Invoices", "i": "fas fa-file-invoice-dollar", "m": "link", "c": "Invoices", "pt": 2,
        // "sm_items": [
        //     {"id": "invoices_client", "t": "Client", "m": "link", "c": "Invoices", "p": "filter=client", "pt": 2},
        //     // {"id": "invoices_contractor", "t": "Contractor", "m": "link", "c": "Invoices", "p": "filter=contractor", "pt": 0},
        // ]
    },
    {
        "id": "quotes", "t": "Quotes", "i": "fas fa-file-invoice", "m": "link", "c": "Quotes", "pt": 2
    },
    {
        "id": "content", "t": "Contents", "i": "fas fa-pencil-alt", "m": "submenu", "c": "Content", "pt": 1,
        "sm_items": [
            {"id": "content_home", "t": "My Home Page", "m": "link", "c": "Contenthomepage", "pt": 1},
            {"id": "content_embed", "t": "Embed Address Search Box", "m": "link", "c": "Contentembed", "pt": 1},
            // {"id": "content_booking", "t": "Booking Page", "m": "link", "c": "Contentbookingpage", "pt": 1},
            // {"id": "content_jobs", "t": "Job Applications", "m": "link", "c": "Contentjobapplications", "pt": 0},
            // {"id": "content_referral", "t": "Referral", "m": "link", "c": "Contentreferral", "pt": 0},
            // {"id": "content_giftcard", "t": "Gift Card", "m": "link", "c": "Contentgiftcard", "pt": 0},
            // {"id": "content_coupon", "t": "Coupon", "m": "link", "c": "Contentcoupon", "pt": 0},
            // {"id": "content_tos", "t": "Terms Of Service", "m": "link", "c": "Contenttos", "pt": 0},
            // {"id": "content_privacy", "t": "Privacy", "m": "link", "c": "Contentprivacy", "pt": 0},
        ]
    },
    {
        "id": "payment_report", "t": "Payment Report", "i": "fad fa-file-chart-pie", "m": "link", "c": "Paymentreport", "pt": 2
    },
    {
        "id": "accounting", "t": "Accounting", "i": "fas fa-calculator-alt", "m": "submenu", "c": "Invoices", "pt": 3,
        "sm_items": [
            {"id": "accounting_expenses", "t": "Expense Report", "m": "link", "c": "Accountingexpenses", "pt": 3},
            {"id": "accounting_category", "t": "Expense Category", "m": "link", "c": "Accountingcategory", "pt": 3},
            {"id": "accounting_pl", "t": "P / L", "m": "link", "c": "Accountingpl", "pt": 3},
        ]
    },
    {"id": "coupons", "t": "Coupons", "i": "fas fa-ticket-alt", "m": "link", "c": "Coupons", "pt": 3},
    {"id": "referrals", "t": "Referrals", "i": "fas fa-hand-holding-usd", "m": "link", "c": "Referrals", "pt": 3},
    // {"id": "gift_cards", "t": "Gift Cards", "i": "fas fa-gift", "m": "link", "c": "Giftcards", "pt": 3},
    {
        "id": "places", "t": "Places", "i": "fas fa-map-marked-alt", "m": "submenu", "m": "link", "c": "Places", "pt": 1
    },
    {
        "id": "settings", "t": "Settings", "i": "fas fa-sliders-h", "m": "submenu", "c": "Settings", "pt": 1,
        "sm_items": [
            {"id": "settings_page", "t": "Page", "m": "link", "c": "Settingspage", "pt": 1},
            {"id": "domain_setting", "t": "Domain", "m": "link", "c": "Settingsdomain", "pt": 1},
            {"id": "settings_pricing", "t": "Pricing", "m": "link", "c": "Settingsprice", "pt": 1},
            // {"id": "settings_email", "t": "Email", "m": "link", "c": "Settingsemail", "pt": 0},
            {"id": "settings_payment", "t": "Payment", "m": "link", "c": "Settingspayment", "pt": 2},
            // {"id": "settings_notification", "t": "Notifications", "m": "link", "c": "Settingsnotification", "pt": 0},
            {"id": "settings_subscription", "t": "Subscription", "m": "link", "c": "Settingssubscription", "pt": 1},
            // {"id": "settings_billing", "t": "Billing", "m": "link", "c": "Settingsbilling", "pt": 1},
            // {"id": "settings_feature", "t": "Feature", "m": "link", "c": "Settingsfeature", "pt": 0},
            {"id": "settings_company", "t": "Company", "m": "link", "c": "Settingscompany", "pt": 1},
        ]
    },
    {
        // "id": "systemcheck", "t": "System Check", "i": "fas fa-laptop-medical", "m": "submenu", "c": "SystemCheck", "pt": 1,
        "id": "systemcheck_logs", "t": "Search Log", "i": "fas fa-laptop-medical", "m": "link", "c": "Searchlog", "pt": 1,
        "sm_items": [
            {"id": "systemcheck_logs", "t": "Search Log", "m": "link", "c": "Searchlog", "pt": 1},
            // {"id": "systemcheck_pricetest", "t": "Price Test", "m": "link", "c": "Pricetest", "pt": 0},
        ]
    }
];

export const able_user_roles = {
    landscaper: ['client', 'contractor', 'employee', 'vendor', 'applicant'],
    admin: ['admin', 'landscaper', 'manager', 'client', 'contractor', 'employee', 'vendor', 'applicant'],
};

export const toast_options =  writable({
});
export const doToast = readable((msg, type, duration=5000, dismissable=false) => {
    let toast_background = "#1c54b2";
    let progress_color = "#2c387e";
    if(type === "error") {
        toast_background = "#f50057";
        progress_color = "#ab003c";
    }

    toast.push(msg, {
        duration: duration, 
        dismissable: dismissable, 
        theme: {
            '--toastBackground': toast_background,
            '--toastProgressBackground':progress_color
        }
    });
});

export const hamburger_menu_open = writable(false);

export const subdomain_manager = writable('');
export const user_store = writable({is_authenticated: false});
export const user_info_store = writable({});
export const domain_code_store = writable('');
export const price_setting_store = writable({});
export const subscription_info_store = writable({ 'basic': 0, 'pro': 0, 'prime': 0, 'free': 0 });
export const pricings_store = writable({});
export const company_details_store = writable({});
export const business_hours_store = writable({});
export const places_store = writable({});
export const user_by_id_store = writable({});
export const all_users_store = writable([]);
export const all_jobs_store = writable([]);
export const all_jobs_number_store = writable(0);
export const all_quotes_store = writable([]);
export const invoices_store = writable([]);
export const transactions_store = writable([]);
export const referrals_store = writable([]);
export const total_earned_store = writable(0);
export const subscription_store = writable({});
export const coupons_store = writable([]);
export const billing_history_store = writable([]);
export const expenses_store = writable([]);
export const expense_category_store = writable([]);
export const page_setting_store = writable({});

///////////////// environment variables
export const redirect_uri = _redirect_uri;
export const cms_host = _cms_host;
export const ppm_host = _ppm_host;
export const STRIPE_PUBLIC_KEY = _STRIPE_PUBLIC_KEY;
export const api_host = _api_host;
export const bpm_domain = _bpm_domain;
export const recaptcha_key = _recaptcha_key;